export const QuoteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <mask
      id="a"
      width="40"
      height="40"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: `alpha` }}
    >
      <path fill="currentColor" d="M0 0h40v40H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="M25.708 28.333l3.334-6.666h-7.375V10h11.666v11.875l-3.208 6.458h-4.417zm-15 0l3.334-6.666H6.667V10h11.666v11.875l-3.208 6.458h-4.417z"
      />
    </g>
  </svg>
)
